// extracted by mini-css-extract-plugin
export var heroImage = "_kf-1";
export var modal = "_kf-0";